import { DocumentFile, OptionFile } from './models/document-file';

const initialFile = {
  file: null,
  fileList: [],
  uploaded: false,
  uploading: false,
  error: null,
};

export const fileDefinitions: OptionFile[] = [
  { name: 'officialIdentification', title: 'Identificación oficial', step: 0 },
  { name: 'proofOfAddress', title: 'Comprobante de domicilio', step: 1 },
  { name: 'rfc', title: 'RFC', step: 2 },
  { name: 'curp', title: 'CURP', step: 3 },
  { name: 'checkbookFace', title: 'Carátula de la chequera', step: 4 },
  { name: 'constitutiveAct', title: 'Acta constitutiva', step: 6 },
  { name: 'authorities', title: 'Poderes', step: 7 },
  {
    name: 'reformAct',
    title: 'Acta escritura reformas (cambio de razón social) si aplica',
    step: 8,
  },
  { name: 'moralPersonRfc', title: 'RFC', step: 9 },
  {
    name: 'moralPersonProofOfAddress',
    title: 'Comprobante de domicilio',
    step: 10,
  },
  {
    name: 'moralPersonCheckbookFace',
    title: 'Carátula de la chequera',
    step: 11,
  },
  {
    name: 'legalRepresentativeId',
    title: 'Identificación oficial del representante legal',
    step: 12,
  },
  {
    name: 'legalRepresentativeRfc',
    title: 'RFC del representante legal',
    step: 13,
  },
  {
    name: 'legalRepresentativeCurp',
    title: 'CURP del representante legal',
    step: 14,
  },
  {
    name: 'legalRepresentativeProofOfAddress',
    title: 'Comprobante de domicilio del representante legal',
    step: 15,
  },
  { name: 'taxCertificate', title: 'Constancia Fiscal', step: 16 },
  {
    name: 'beneficiariesOfficialIds',
    title: 'Identificación oficial de beneficiario',
    step: 17,
  },
  { name: 'profiling', title: 'Perfilamiento', step: 18 },
  { name: 'gpaContract', title: 'Contrato GPAT', step: 20 },
];

const optionFiles: Record<string, OptionFile> = Object.fromEntries(
  fileDefinitions.map(({ name, title }) => [name, { name, title }]),
);

const initialFiles: Record<string, typeof initialFile> = Object.fromEntries(
  fileDefinitions.map(({ name, step }) => [name, { ...initialFile, step }]),
);

const physicalPersonKeys = [
  'officialIdentification',
  'proofOfAddress',
  'rfc',
  'taxCertificate',
  'curp',
  'checkbookFace',
  'beneficiariesOfficialIds',
];

const physicalCoOwnersInitialFilesKeys = [
  'officialIdentification',
  'proofOfAddress',
  'rfc',
  'curp',
  'checkbookFace',
];

const suraPhysicalPersonKeys = [
  'officialIdentification',
  'proofOfAddress',
  'rfc',
  'taxCertificate',
  'curp',
  'checkbookFace',
  'profiling',
  'beneficiariesOfficialIds',
  'gpaContract',
];

const moralPersonKeys = [
  'constitutiveAct',
  'authorities',
  'reformAct',
  'moralPersonRfc',
  'moralPersonProofOfAddress',
  'moralPersonCheckbookFace',
  'legalRepresentativeId',
  'legalRepresentativeRfc',
  'legalRepresentativeCurp',
  'legalRepresentativeProofOfAddress',
];

const suraMoralPersonKeys = [
  'constitutiveAct',
  'authorities',
  'reformAct',
  'moralPersonRfc',
  'moralPersonProofOfAddress',
  'moralPersonCheckbookFace',
  'legalRepresentativeId',
  'legalRepresentativeRfc',
  'legalRepresentativeCurp',
  'profiling',
  'legalRepresentativeProofOfAddress',
  'gpaContract',
];

const buildPersonFiles = (keys: string[]) =>
  keys.map((key) => optionFiles[key]);

const buildPersonInitialFiles = (keys: string[]): DocumentFile =>
  Object.fromEntries(
    keys.map((key) => [key, initialFiles[key]]),
  ) as any as DocumentFile;

// Mapa de archivos por persona
export const personFilesMap = {
  cotitular: buildPersonFiles(physicalCoOwnersInitialFilesKeys),
  fisica: buildPersonFiles(physicalPersonKeys),
  suraFisica: buildPersonFiles(suraPhysicalPersonKeys),
  moral: buildPersonFiles(moralPersonKeys),
  suraMoral: buildPersonFiles(suraMoralPersonKeys),
};

// Mapa de archivos iniciales por persona
export const initialFilesMap = {
  cotitular: buildPersonInitialFiles(physicalCoOwnersInitialFilesKeys),
  fisica: buildPersonInitialFiles(physicalPersonKeys),
  suraFisica: buildPersonInitialFiles(suraPhysicalPersonKeys),
  moral: buildPersonInitialFiles(moralPersonKeys),
  suraMoral: buildPersonInitialFiles(suraMoralPersonKeys),
};

export const DOCUMENTS_WITH_FULL_TABLE_COLUMNS = [
  'officialIdentification',
  'legalRepresentativeId',
] as const;
